import { decoratePointOfWorks } from '../../../helpers/decoratePointOfWorks'
import { axios } from '../../../lib'

export const getCostCenters = (cif) => {
  return axios.get(`/nomenclatures/cost-centers/${cif}`)
}

export const getExpenseGroups = ({ cif, orderByList }) => {
  return axios.get(`/nomenclatures/expense-groups/${cif || ""}`, {
    orderByList
  })
}

export const getOrganisations = ({
    categories = null,
  pointOfWorks = null,
  partners = null,
  statuses = null,
  invoiceGroups = null,
  companies = null,
} = {}) => {
  return axios.post('/v2/nomenclatures/companies', {
    selectedFilters: {
      categories,
      pointOfWorks,
      partners,
      statuses,
      invoiceGroups,
      companies,
    }
  })
}

export const getProjects = ({ cif, orderByList }) => {
  return axios.get(`/nomenclatures/projects/${cif}`, {
    orderByList
  })
}

export const getGroups = (cif) => {
  return axios.get(`/nomenclatures/document-groups/${cif}`)
}

export const getStatuses = ({
  categories = null,
  pointOfWorks = null,
  partners = null,
  statuses = null,
  invoiceGroups = null,
  companies = null,
} = {}) => {
  return axios.post('/v2/nomenclatures/statuses',{
    selectedFilters: {
      categories,
      pointOfWorks,
      partners,
      statuses,
      invoiceGroups,
      companies,
    }
  })
}

export const getInvoiceGroups = ({
                              categories = null,
                              pointOfWorks = null,
                              partners = null,
                              statuses = null,
  invoiceGroups = null,
                              companies = null,
                            } = {}) => {
  return  axios.post('/v2/nomenclatures/invoiceGroups',{
    selectedFilters: {
      categories,
      pointOfWorks,
      partners,
      statuses,
      invoiceGroups,
      companies,
    }
  })
}

export const getCategories = ({
  categories = null,
  pointOfWorks = null,
  partners = null,
  statuses = null,
  invoiceGroups = null,
  companies = null,
} = {}) => {
  return axios.post('/v2/nomenclatures/categories',{
    selectedFilters: {
      categories,
      pointOfWorks,
      partners,
      statuses,
      invoiceGroups,
      companies,
    }
  })
}

export const getArticles = ({
  expenseGroups,
  searchTerm = null,
  cif = null,
  orderByList = null,
  pageNumber = null,
  names = null,
  size = null
}) => {
  return axios.post('/nomenclatures/articles/paginate', {
    expenseGroups,
    searchTerm,
    cif,
    names,
    pagination: {
      ...(pageNumber == null || size == null
        ? { pageNumber: null, size: null }
        : { pageNumber, size }),
      orderByList
    }
  })
}

export const getPartners = ({
  pageNumber = null,
  cif=null,
  size = null,
  orderByList = null,
  searchTerm,
  categories = null,
  pointOfWorks = null,
  partners = null,
  statuses = null,
  companies = null,
  invoiceGroups = null,
}) => {
  return axios.post(`/v2/nomenclatures/partners/paginate`, 
    {
      searchTerm,
      cif,
      pagination: {
        ...(pageNumber == null || size == null
          ? { pageNumber: null, size: null }
          : { pageNumber, size }),
        orderByList,
      },
      selectedFilters: {
      categories,
      pointOfWorks,
      partners,
      statuses,
        invoiceGroups,
      companies,
    }
    }
  ).then((response) => {
    if (pageNumber === 0 && !searchTerm) {
      const naItem = { cif: 'null', name: 'N/A', worldClassCif: '', partnerGroup: '' };
      const content = Array.isArray(response?.content) ? response.content : [];
      response = { 
        ...response,
        content:[naItem, ...content],
      };
    }
    return response;
  })
};

export const getAllPointOfWorks = ({
  cif = null,
  code = null,
  searchTerm = null,
  orderByList = null,
  pageNumber = null,
  size = null,
}) => {
  return axios.post('/nomenclatures/point-of-works/paginate', {
    cif,
    code,
    searchTerm,
    pagination: {
      ...(pageNumber == null || size == null
        ? { pageNumber: null, size: null }
        : { pageNumber, size }),
      orderByList
    },
  })
}


export const getPointOfWorks = ({
  cif = null,
  code = null,
  searchTerm = null,
  orderByList = null,
  pageNumber = null,
  size = null,
  categories = null,
  pointOfWorks = null,
  partners = null,
  statuses = null,
  companies = null,
  invoiceGroups = null,
}) => {
  return axios.post('/v2/nomenclatures/point-of-works/paginate', {
    cif,
    code,
    searchTerm,
    pagination: {
      ...(pageNumber == null || size == null
        ? { pageNumber: null, size: null }
        : { pageNumber, size }),
      orderByList
    },
    selectedFilters: {
      categories,
      pointOfWorks,
      partners,
      statuses,
      companies,
      invoiceGroups,
    }
  })
}

export const getDecoratedPointOfWorks = async ({
  searchTerm = null,
  cif=null,
  categories = null,
  pointOfWorks = null,
  partners = null,
  statuses = null,
  companies = null,
  invoiceGroups = null,
}) => {
  const rawPointsOfWorks = await getPointOfWorks({cif: cif, searchTerm: searchTerm, categories: categories, pointOfWorks: pointOfWorks, partners: partners, statuses: statuses, companies: companies, invoiceGroups: invoiceGroups})
  const decoratedPointOfWorks = await decoratePointOfWorks(rawPointsOfWorks.content)
  return decoratedPointOfWorks
}
